import { useCallback, useMemo, useRef, useState } from 'react'

import './index.scss'
import Button from '../Button'
import { useTranslation } from 'react-i18next'
import DropDownSelection from '../DropdownSelection'
import { useClickOutside } from '../../hooks/useClickOutside'
import { useNavigate } from 'react-router-dom'
import { COLOR } from '../../data/variables'
import { ICON } from '../Icon/data'
import Icon from '../Icon'
import { useManagement } from '../../hooks/useManagement'

const AdminToolsWidget = () => {
  const { t } = useTranslation()
  const dropdownRef = useRef()
  const navigate = useNavigate()
  
  const { showAdmin, options: manOptions } = useManagement()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const label = useMemo(() => {
    return (
      <div className="AdminToolsWidget__label">
        {t('Admin tools')}
        <Icon icon={ICON.USER_ADMIN} size={16} color={isOpen ? COLOR.WHITE : COLOR.TEXT_GRAY} />
      </div>
    )
  }, [t, isOpen])

  const navigateToPage = useCallback((path: string) => {
    navigate(path)
    setIsOpen(false)
  }, [navigate])

  const options = useMemo(() => {
    return manOptions.map((option) => {
      return {
        ...option,
        onClick: () => navigateToPage(option.url)
      }
    })
  }, [manOptions, navigateToPage])

  if (!showAdmin) return null

  return (
    <div className="AdminToolsWidget">
      <Button
        label={label}
        size="s" type="tertiary"
        onClick={() => setIsOpen(!isOpen)}
        isActive={isOpen}
      />
      {isOpen && (
        <div ref={dropdownRef} className="AdminToolsWidget__dropdown">
          <DropDownSelection options={options} />
        </div>
      )}
    </div>
  )
}

export default AdminToolsWidget
